import React, { FC } from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { List } from "antd";
import { ActionBanner } from "../ActionBanner";
import { CMSSection, CMSCTA } from "../models";
import { JHTML } from "../JHTML";


export type HowToProps = CMSSection & {
    onNavigate:  (type: string, params?: Record<string, any>) => void;
};

/**
 * How To component
 *
 * @param {HowToProps} props
 * @return {*}
 */
export const HowTo: FC<HowToProps> = (props) => {
    
    const onClickCallback = (cta: CMSCTA) => {
        
        if ( cta.href && cta.href.value && cta.href.type === "EXTERNAL" ) {
            const anchor = document.createElement('a');
            const name = cta.href.value.replace(/^.*[\\\/]/, '')
            const url = cta.href.value
            const target = cta.href.target
            anchor.setAttribute('href', url);
            if (target) {
                anchor.setAttribute('target', target);
            }
            anchor.innerHTML = name
            document.body.appendChild(anchor);
            anchor.click();
            if (anchor.parentNode) anchor.parentNode.removeChild(anchor);
            return;
        }
        
        cta?.scope && props?.onNavigate(cta?.scope);
    }
    
    return (
        <div className="how-to-container">
            {props?.title && <JHTML.Title html={props?.title}/>}
            {props?.text && <JHTML.Text html={props?.text}/>}
            <div>
                {!!props?.sections?.length &&
                    <div className="how-to-data">
                        <List
                            dataSource={props?.sections}
                            renderItem={(item : CMSSection, index: number) => (
                                <List.Item key={index}>
                                    <List.Item.Meta
                                        avatar={<QuestionCircleOutlined aria-hidden={true} />}
                                        title={item?.text ? <JHTML.Text html={item?.text}/> : ''}
                                    />
                                </List.Item>
                            )}
                        />
                    </div>
                }
                {props?.cta && props?.cta.map((cta : CMSCTA, i: number) => {
                    return (<ActionBanner key={i} small title={cta?.title as string} actionCallback={() => onClickCallback(cta)} />)
                })
                }
            </div>
        </div>
    )
}
